<template>
    <div>
        <div>
        <BButton variant="secondary" id="calcButton" 
        v-b-tooltip.hover title="Clique Para Calcular O Valor Para Embalagens ou Pacotes">
            <BIcon style="width: 0.7rem;" scale="2" 
            icon="calculator-fill" v-b-modal.calculator />
        </BButton>
        </div>

        <BTooltip target="calcButton" triggers="hover">
            Clique para Calcular o valor para Embalagens ou pacotes.
        </BTooltip>

        <b-modal id="calculator" title="Calculadora" @ok="doCalc">
            <BRow class="mt-1">
                <BCol sm="12">
                    <p class="m-1 px-1 text-primary">Calculadora para Preço de material quando a compra foi feita por embalagens, pacotes ou rolos.</p>
                    <BForm class="p-2">
                        <BFormGroup id="priceInputSet"                             
                            description="Insira o Preço Pago Pela Embalagem ou Pacote"     
                            label-for="priceInput"
                            >

                            <label class="font-weight-bold" for="priceInput">Preço do Material</label>
                            
                            <BInputGroup>
                                <BInputGroup-prepend is-text>
                                    R$
                                </BInputGroup-prepend>
                                <BFormInput id="priceInput" type="text" 
                                    trim placeholder="Insira o valor pago pela embalagem ou total em Kg"
                                    v-model="priceMaterial"
                                    v-currency
                                    required />
                            </BInputGroup>
                        </BFormGroup>

                         <BFormGroup id="qtdInputSet" 
                            description="Insira a quantidade de material que vem na caixa, pacote ou rendimento por metro"             
                            label-for="qtdInput"
                            >

                            <label class="font-weight-bold" for="qtdInput">Quantidade de Material Por Embalagem/Rendimento</label>
                            
                            <BFormInput id="qtdInput" type="text"                                
                                placeholder="Quantas Unidades Vem Na Embalagem Comprada ou Rendimento"
                                v-model="qtdMaterial"    
                                                      
                                />   
                                                            
                        </BFormGroup>

                    </BForm>

                </BCol>
            </BRow>
            <BRow>
                <BCol sm>
                    <BAlert :show="showAlert" :variant="variantAlert" dismissible @dismissed="resetMessages()">
                        <p v-for="message in messageAlert" :key="message">
                            {{ message }}
                        </p>
                    </BAlert>
                </BCol>
            </BRow>
        </b-modal>
        
    </div>
</template>

<script>

export default {
    data() {
        return {
            priceMaterial:  null,
            qtdMaterial: null,
            showAlert: null,
            variantAlert: "danger",
            messageAlert: []
        }     
    },
    methods: {
        doCalc(bvModalEvent) {
            let validate = true
            bvModalEvent.preventDefault()
            
            if (this.priceMaterial <= 0) {
                this.showAlert = 5
                this.variantAlert = "warning"
                this.messageAlert.push("Para Realizar um Cálculo Digite um Preço Válido")
                this.priceMaterial = null
                validate = false                
            }

            if (this.qtdMaterial <= 0) {
                this.showAlert = 5
                this.variantAlert = "warning"
                this.messageAlert.push("Para Realizar um Cálculo Digite uma Quantidade Maior Que Zero")
                this.qtdMaterial = null
                validate = false                
            }

            
            if (validate) {
                
                const result = (parseFloat(this.priceMaterial.replace(",",".")) / parseFloat(this.qtdMaterial.replace(",","."))).toFixed(2)
                
                this.$emit("doCalc", result)
                this.$nextTick(() => {
                    this.$bvModal.hide('calculator')
                })
            }
        },
        resetMessages() {
            this.showAlert=0
            this.messageAlert=[]
        }
    }
}
</script>
<style lang="">
    
</style>